export default __webpack_public_path__ + "static/media/logoPlacement.236c1fc4.svg";